import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LockIcon from '@mui/icons-material/Lock';

const RendererLockedScreen = ({ data = {} }) => {
  const { message, lockedByName, redirectUrl } = data;

  const displayMessage = message || (lockedByName
    ? `This renderer is currently locked by ${lockedByName}. Please choose a different renderer.`
    : 'This renderer is currently locked by a supervisor. Please choose a different renderer.');

  const handleGoToRenderers = () => {
    sessionStorage.removeItem('aedrive_locked_data');
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          padding: 4,
          maxWidth: 420,
          border: '1px solid rgba(255, 255, 255, 0.12)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <LockIcon sx={{ fontSize: 48, color: 'warning.main' }} />
        <Typography
          variant="h6"
          sx={{ color: 'text.primary', fontWeight: 500 }}
        >
          {displayMessage}
        </Typography>
        {redirectUrl && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoToRenderers}
            sx={{ mt: 1 }}
          >
            Go to Renderer List
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default RendererLockedScreen;
